const pdfCache: { [documentId: string]: string } = {};

export default pdfCache;
